module.exports = __webpack_public_path__ + "img/systems.dd55195b.png";